<div class="main-content" *ngIf="erpS.modulos">
    <div class="main-bar p-px-10 custom-scrollbar">
        <div class="module" (click)="tempModule=modulo.key;viewTypes=true"
            *ngFor="let modulo of erpS.modulos | keyvalue" [ngClass]="{'selected':selectedModule==modulo.key}">
            <img src="/assets/icons/module.svg" alt="" class="icon">
            <div class="title">
                {{modulo.value.nom_obj}}
            </div>
        </div>
    </div>
    <div class="main-bar second p-px-10 custom-scrollbar" [ngClass]="{'active':viewTypes}">
        <div class="module" *ngFor="let type of types | keyvalue"
            (click)="selectedType=type.key;selectedModule=tempModule;viewTypes=false">
            <img src="/assets/icons/module.svg" alt="" class="icon">
            <div class="title">
                {{type.value}}
            </div>
        </div>
    </div>
    <div class="content-modules" *ngIf="erpS.modulos[selectedModule]">
        <h1 class="title">{{erpS.modulos[selectedModule].nom_obj}}</h1>
        <div class="desc fz-20 p-px-l-5 m-px-b-30">
            {{erpS.modulos[selectedModule].descripcion}}
        </div>
        <h2 class="p-px-l-20">{{types[selectedType]}}</h2>
        <div class="row no-gutters m-px-0 p-px-x-20">
            <div class="col-6 p-px-20" *ngFor="let modulo of erpS.modulos[selectedModule].modulos | keyvalue"
                [ngClass]="{'d-none':modulo.value.ctipo_obj!=selectedType}">
                <div class="card modulo-desc" [routerLink]="[modulo.value.path]">
                    <img src="/assets/icons/module.svg" alt="" class="icon centrado-v">
                    <h3 class="title">{{modulo.value.nom_obj}}</h3>

                    <div class="desc">{{modulo.value.descripcion}}</div>
                </div>
            </div>
        </div>
    </div>
</div>